// REACT
import { Link } from "react-router-dom";
import { useContext } from "react";

// ASSETS
import logo from "../assets/images/logo.png";
import languagePack from "../assets/languages/languagePack";

// CONTEXT
import { maincontext } from "../context/maincontext";

export default function NotFound() {
    const { language } = useContext(maincontext);

    return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center bg-light px-3">
            <img
                src={logo}
                alt="Logo"
                className="mb-4 img-fluid"
                style={{ maxWidth: "120px" }}
            />
            <h1 className="display-4 text-dark">404 - {languagePack[language].errorPage.pageNotFound}</h1>
            <p className="lead text-muted mb-4">
                {languagePack[language].errorPage.pageNotFound2}
            </p>
            <Link to="/" className="btn btn-primary px-4 py-2">
                {languagePack[language].errorPage.goBackHome}
            </Link>
        </div>
    );
}
